import { FC } from 'react'
import {
  DropDownList,
  DropDownListChangeEvent,
  DropDownListProps
} from '@progress/kendo-react-dropdowns'

import { useAppSelector } from '../../stores'

interface DepartmentDropDownListProps
  extends Omit<
  DropDownListProps,
  'data' | 'dataItemKey' | 'textField' | 'onChange'
  > {
  /** CODE */
  defaultValue?: string
  /** CODE */
  value?: string
  /**
   * @param value CODE
   */
  onChange?: (value: string) => void
}

export const DepartmentDropDownList: FC<DepartmentDropDownListProps> = ({
  value,
  defaultValue,
  onChange,
  ...restProps
}) => {
  const common = useAppSelector((x) => x.common)
  const codeNames = common.initialData.codeNames('TY02')

  const createValue = (codeValue?: string) => {
    if (codeValue === undefined) {
      return null
    }

    const value = codeNames.find((codeName) => codeName.CODE === codeValue)

    return value === undefined ? null : value
  }

  const handleOnChange = (event: DropDownListChangeEvent) => {
    onChange?.(event.value.CODE)
  }

  return (
    <DropDownList
      {...restProps}
      data={codeNames}
      dataItemKey="CODE"
      textField="NAME"
      defaultValue={createValue(defaultValue)}
      value={createValue(value)}
      onChange={handleOnChange}
    />
  )
}
